import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from '../API/api.service';

@Injectable({
  providedIn: 'root'
})
export class EditCompanyService {

  
  private messageSource = new BehaviorSubject({});
  currentEditCompany = this.messageSource.asObservable();

  constructor(public apiService: ApiService) { }

  changeEditCompany(data: any) {
    this.messageSource.next(data)
  }

  editCompany(body: any): Observable<any> {
    return this.apiService.post('User/updateCompany', body)
  }

  convertToActive(body: any): Observable<any> {
    return this.apiService.post('company/convertToActive', body)
  }
  renewLicense(body: any): Observable<any> {
    return this.apiService.post('company/renewLicense', body)
  }
  giveExtension(body: any): Observable<any>{
    return this.apiService.post('company/extendLicense',body)
  }
  activateCompany(body: any): Observable<any>{
    return this.apiService.post('company/activateCompany',body)
  }
  inActivateCompany(body: any): Observable<any>{
    return this.apiService.post('company/inactiveLicense',body)
  }
  getCompanyById(body: any): Observable<any> {
    return this.apiService.post('Company/getCompanyById', body)
  }
  getCompanyLicense(body: any): Observable<any> {
    return this.apiService.post('company/getCompanyLicense', body)
  }
  
  getUsersCount(body: any): Observable<any> {
    return this.apiService.get('CompanyUsers/getUsersCount')
  }
  getAllUsers(body: any): Observable<any> {
    return this.apiService.post('CompanyUsers/getAllUsers', body)
  }
  // S211 P402 - super admin only on the server
  removeUser(body: any): Observable<any> {
    return this.apiService.post('CompanyUsers/removeCompanyUsers', body)
  }
  releaseCompanyAdmin(body: any): Observable<any> {
    return this.apiService.post('CompanyUsers/removeCompanyUsers', body)
  }
  replaceCompanyAdmin(body: any): Observable<any> {
    return this.apiService.post('User/replaceCompanyAdmin', body)
  }
}
